import { StandardEvents } from '@shopify/events';

// This custom header lives outside Horizon's cart-icon component.
if (!window.orevyrShellReady) {
  window.orevyrShellReady = true;
  const renderCount = (count) => {
    if (!Number.isFinite(count)) return;
    document.querySelectorAll('[data-or-cart-count]').forEach((el) => { el.textContent = String(count); });
  };
  const refreshCount = async () => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (response.ok) renderCount((await response.json()).item_count);
    } catch (_) { /* Leave the server-rendered count intact if offline. */ }
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (!event.promise) return;
    event.promise.then(({ cart }) => {
      if (Number.isFinite(cart?.totalQuantity)) renderCount(cart.totalQuantity);
      else refreshCount();
    }).catch(() => {});
  });
  window.addEventListener('pageshow', (event) => { if (event.persisted) refreshCount(); });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.or-header__menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary')?.focus(); }
  });
  document.addEventListener('click', (event) => {
    const menu = document.querySelector('.or-header__menu[open]');
    if (menu && !menu.contains(event.target)) menu.open = false;
  });
}
